export const glosarioProceso1 = {
    RECLUTADOR: {
        id: "RECLUTADOR",
        name: "Reclutador",
        midAge: 2,
        maxAge: 5
    },
    VALIDACION_RECLUTADOR: {
        id: "VALIDACION_RECLUTADOR",
        name: "Validación",
        midAge: 2,
        maxAge: 5
    },
    PUBLICACION: {
        id: "PUBLICACION",
        name: "Publicación Vacante",
        midAge: 1,
        maxAge: 2
    },
    REMISION: {
        id: "REMISION",
        name: "Remisión HV",
        midAge: 1,
        maxAge: 2
    },
    REVISION_OPERACIONES: {
        id: "REVISION_OPERACIONES",
        name: "Revisión Operaciones",
        midAge: 1,
        maxAge: 2
    },
    PRUEBAS: {
        id: "PRUEBAS",
        name: "Pruebas Técnicas",
        midAge: 1,
        maxAge: 2
    },
    ENTREVISTA: {
        id: "ENTREVISTA",
        name: "Entrevista",
        midAge: 1,
        maxAge: 2
    },
    VALIDACION: {
        id: "VALIDACION",
        name: "Validación HV",
        midAge: 1,
        maxAge: 2
    },
    ESTUDIO_SEGURIDAD: {
        id: "ESTUDIO_SEGURIDAD",
        name: "Estudio de Seguridad",
        midAge: 2,
        maxAge: 3
    },
    EXAMEN_MEDICO: {
        id: "EXAMEN_MEDICO",
        name: "Examen Médico",
        midAge: 2,
        maxAge: 3
    },
    LISTA_CHEQUEO: {
        id: "LISTA_CHEQUEO",
        name: "Lista de Chequeo",
        midAge: 0.5,
        maxAge: 1
    },
    REVISION: {
        id: "REVISION",
        name: "Paso a Contratación",
        midAge: 1,
        maxAge: 2
    }
    // INGRESO: {
    //     id: "INGRESO",
    //     name: "Ingreso",
    //     midAge: 2,
    //     maxAge: 3
    // }
}